var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    role: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Supplier") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 3.5,
    width: 6,
    height: 5.5,
    rx: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 3.5v2.5h3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5c2 0 3.5-.5 5 .5 1.3.9 2.4 1 3.5.3l1.2-.7a2.5 2.5 0 0 1 3 4.1l-1.1.6a6 6 0 0 1-5.7 0l-1.7-.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5v2.5a2 2 0 0 0 2 2h2.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/supplier.c5ff7cd74f0aaab65114fb0a10b024b2.svg";
export { ForwardRef as ReactComponent };